import { mapFromOidcLoginInfo } from 'mappings/oidcLoginInfoMapping';
import OidcLoginInfoDTO from 'dto/identity/oidcLoginInfoDTO';
import { OidcIssuerInfo } from 'models/identity/identityProvider';
import AppError from 'utils/appError';
import http from './httpService';

/**
 * Which allow-listed OpenID Connect issuer signs a person in: by the domain of their e-mail address, or by
 * the issuer URL of an organization. Anonymous: there is no token yet. Undefined when none is allow-listed.
 */
export async function apiGetOidcLoginInfo(
  email: string | undefined,
  issuer: string | undefined,
): Promise<OidcIssuerInfo | undefined> {
  try {
    const params = new URLSearchParams();
    if (email) params.append('email', email);
    if (issuer) params.append('issuer', issuer);

    const ar = await http.get<OidcLoginInfoDTO>(`/identity/oidc/login-info?${params.toString()}`);

    if (!ar.data || !ar.data.issuer) return undefined;

    return mapFromOidcLoginInfo(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
